module.exports = __webpack_public_path__ + "img/15-1.e508f605.jpg";